import { PostArticle } from "../../common/entities/PostArticle";

export type PostArticlesShowState = {
  post: PostArticle;
};

const initialState: PostArticlesShowState = {
  post: {} as PostArticle,
};

export default function entitiesReducer(state = initialState, action: any): PostArticlesShowState {
  switch (action.type) {
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/post_articles/reducers/showReducer.ts